import { useContext } from "react";
import { AccessibilityContext } from "./accessibility-provider";

/**
 * Custom hook to access the Accessibility context.
 * @returns {Object} The Accessibility context object.
 */
const useAccessibilityContext = () => {
  const accessibilityContext = useContext(AccessibilityContext);
  return accessibilityContext;
};

export default useAccessibilityContext;
